import { useState } from 'react'
import Typography from '../atoms/Typography'
import { Input } from '../atoms/inputs/Input'
import RatingFrameworkSelector from './RatingFrameworkSelector'
import { RatingFramework } from '../../types/ratingFramework'

interface RatingInputProps {
  defaultFramework?: RatingFramework | null
  defaultGrade?: string | null
  onFrameworkChange: (frameworkId: string | null) => void
  onGradeChange: (grade: string) => void
  frameworkError?: string
  gradeError?: string
  disabled?: boolean
}

const RatingInput = ({
  defaultFramework,
  defaultGrade,
  onFrameworkChange,
  onGradeChange,
  frameworkError,
  gradeError,
  disabled,
}: RatingInputProps) => {
  const [hasFramework, setHasFramework] = useState(!!defaultFramework)
  const [grade, setGrade] = useState(defaultGrade || '')

  const handleFrameworkChange = (frameworkId: string | null) => {
    setHasFramework(!!frameworkId)
    onFrameworkChange(frameworkId)
    if (!frameworkId) {
      setGrade('')
      onGradeChange('')
    }
  }

  const handleGradeChange = (value: string) => {
    setGrade(value)
    onGradeChange(value)
  }

  return (
    <div className="space-y-3">
      <Typography variant="sm-medium" element="label" className="block text-gray-50">
        Rating <span className="text-gray-300">(optional)</span>
      </Typography>
      <RatingFrameworkSelector
        defaultValue={defaultFramework}
        onFrameworkChange={handleFrameworkChange}
        errorMessage={frameworkError}
        placeholder="Search framework"
      />
      {hasFramework && (
        <Input
          type="text"
          disabled={disabled}
          autoComplete="off"
          maxLength={50}
          value={grade}
          onChange={(e) => handleGradeChange(e.target.value)}
          errorMessage={gradeError}
          placeholder="Grade, e.g. AA"
          className="placeholder:text-gray-300"
        />
      )}
    </div>
  )
}

export default RatingInput
